<edit-message-navbar
  [penmate]="penmate"
  [back]="onGoBack"
  [showHelp]="true"
  [showPenmateName]="true"
  [destroyBeaconOnClose]="true"
  [destroyBeaconOnDestroy]="true"
  [beaconDisplayStyle]="'manual'"
>
</edit-message-navbar>

<div
  class="pm-react-messenger__id-verification"
  *ngIf="showIdVerificationBanner"
  (click)="onGoToMyAccount()"
  role="button"
  tabindex="0"
  aria-label="Delivery verification required. Open My Account."
>
  <div class="pm-react-messenger__id-verification__content">
    <ion-icon name="ios-alert" class="pm-react-messenger__id-verification__icon"></ion-icon>
    <div class="pm-react-messenger__id-verification__text ph-mask">
      {{ idVerificationBannerText }}
    </div>
  </div>
  <div class="pm-react-messenger__id-verification__actions">
    <div class="pm-react-messenger__id-verification__cta">
      My Account
      <ion-icon name="ios-arrow-forward" class="pm-react-messenger__id-verification__arrow"></ion-icon>
    </div>
    <button
      type="button"
      class="pm-react-messenger__id-verification__close"
      (click)="onDismissIdVerificationBanner($event)"
      aria-label="Dismiss verification reminder"
    >
      <ion-icon name="close"></ion-icon>
    </button>
  </div>
</div>

<div class="pm-react-messenger__shell">
  <div class="pm-react-messenger__boot" *ngIf="isBooting">
    <pm-skeleton-loader loading-text="Loading…"></pm-skeleton-loader>
  </div>

  <div class="pm-react-messenger__boot pm-react-messenger__boot--error" *ngIf="bootError">
    <div class="pm-react-messenger__boot-text">
      <div class="title">Unable to load messages</div>
      <div class="subtitle">{{ bootError }}</div>
    </div>
  </div>

  <div class="pm-react-messenger__host" [class.pm-react-messenger__host--hidden]="isBooting" #host></div>
</div>
